import { AppRouteProps } from "@bsm/component";
import ProjectTimeOffCreateLeavingContainer from "../leaving/container/ProjectTimeOffCreateLeavingContainer";

export const ProjectAppointmentCreateVacationRoutes: Array<AppRouteProps> = [
  {
    path: "leave",
    title: "BSMRH.Project.Appointment.Create.Label",
    element: <ProjectTimeOffCreateLeavingContainer />,
  },
];